import React from 'react'

function AboutSection() {
  return (
    <section className='mt-[20px]'>
        <div className='container'>
           
            <div className='grid grid-cols-2 gap-[20px] mt-[20px] items-center'>
                <div className='flex flex-col gap-[7px]'>
                    <h2 className='text-left text-[#3a3a3a] text-[36px] font-[600]'>
                        <span className='border-b border-b-[#bb222b] border-b-[4px]'>MEP Fire is one of the UK's </span>leading specialist fire suppression system contractors
                    </h2>
                    <p className='text-gray-800 font-[400] mt-[60px]'>At MEP Fire, our dedicated team of Fire Suppression professionals provide an unmatched service to clients across the UK. </p>
                    <p className='text-gray-800 font-[400]'>We offer the full range of services such as; Design, Supply, Installation and maintenance of a specialist fire suppression systems which include Inert Gas Systems, Watermist Systems, Condensed Aerosol Systems and Kitchen Fire Suppression Systems.</p>
                    <p className='text-gray-800 font-[400]'>We strive to convey reliability, integrity and professionalism in every project we undertake.</p>
                    <p className='text-gray-800 font-[400]'> We’re genuinely committed to customer satisfaction and aim to build a reputation, loyalty and long-lasting relationships throughout our network.</p>
                   
                </div>
                <div className='grid grid-cols-2 gap-[20px]'>
                    <div className='flex flex-col gap-[20px]'>
                        <div className='border border-gray-300 h-[300px] rounded-[10px]'>
                            <img className='w-full h-full object-fill rounded-[10px]' src="https://lirp.cdn-website.com/f0579b03/dms3rep/multi/opt/FIA+certificate+1-1920w.png" />
                        </div>
                        <div className='border border-gray-300 h-[300px] rounded-[10px]'>
                            <img className='w-full h-full object-fill rounded-[10px]' src="https://lirp.cdn-website.com/f0579b03/dms3rep/multi/opt/FIA+certificate+1-1920w.png" />
                        </div>
                    </div>
                    <div className='flex flex-col gap-[20px] mt-[80px]'>
                        <div className='border border-gray-300 h-[300px] rounded-[10px]'>
                            <img className='w-full h-full object-fill rounded-[10px]' src="https://lirp.cdn-website.com/f0579b03/dms3rep/multi/opt/FIA+certificate+1-1920w.png" />
                        </div>
                        <div className='border border-gray-300 h-[300px] rounded-[10px]'>
                            <img className='w-full h-full object-fill rounded-[10px]' src="https://lirp.cdn-website.com/f0579b03/dms3rep/multi/opt/FIA+certificate+1-1920w.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default AboutSection